import React, {
  useEffect, useContext, useState, useRef,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CSVLink } from 'react-csv';
import { useHistory, useParams } from 'react-router';
import { useInView } from 'react-intersection-observer';
import Select from 'react-select';

import { ReactSVG } from 'react-svg';
import getConfig from '../../config';
import { handleResponseStatus, sendRequest } from '../../utils/api-request';
import { REGISTER_STATUS } from '../../constans/constans';
import { appStore } from '../../state/app';
import {
  buildGatewayUrl, getFilesFromDirectory, getJSONFileFromIpfs, initIPFS,
} from '../../state/ipfs';
import { runtimeMappings, getMapping } from '../../utils/runtime-mappings';

import Loader from '../../components/Loader/Loader';
import RequestModal from '../../components/RequestModal/RequestModal';
import PreviewSampleZone from '../StageReport/components/PreviewSampleZone/PreviewSampleZone';
import MapMini from '../../components/Map/components/MapMini/MapMini';
import mark from '../../assets/image/mark.svg';

const { indexerApi } = getConfig();

const CustomSelect = ({ defaultValue, options, selectOnChange }) => {
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: '#329d9c',
      padding: 12,
      borderRadius: 8,
      border: 'none',
      boxShadow: 'none',
      cursor: 'pointer',
      '&:hover': {
        border: 'none',
        boxShadow: 'none',
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: 0,
      height: '27px',
    }),
    placeholder: (styles) => ({
      ...styles,
      margin: 0,
      fontSize: 18,
      lineHeight: '27px',
      fontWeight: 700,
      color: '#ffffff',
    }),
    singleValue: (styles) => ({
      ...styles,
      margin: 0,
      fontSize: 18,
      lineHeight: '27px',
      fontWeight: 700,
      color: '#ffffff',
    }),
    dropdownIndicator: (styles, { selectProps: { menuIsOpen } }) => ({
      ...styles,
      padding: 0,
      transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      color: '#ffffff',
      '&:hover': {
        color: '#ffffff',
      },
      svg: {
        width: 24,
        height: 24,
      },
    }),
    menu: (styles) => ({
      ...styles,
      width: 228,
      marginTop: 8,
      padding: 0,
      borderRadius: 8,
      border: '1px solid #D5D9E7',
      boxShadow: 'none',
      zIndex: 20,
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: 'red',
    }),
    multiValue: () => ({
      // ...styles,
      color: 'red',
    }),
    option: (styles, { data, isSelected }) => ({
      ...styles,
      backgroundColor: 'white',
      color: data.isCurrentStage ? '#cdcece' : '#1c505d',
      fontSize: 14,
      position: 'relative',
      lineHeight: '15px',
      paddingLeft: 12,
      cursor: 'pointer',
      ':active': {
        ...styles[':active'],
        backgroundColor: isSelected ? 'rgba(50, 157, 156, 0.2);' : 'white',
      },
    }),
  };
  const CustomOption = (props) => {
    const { data, label, innerProps } = props;
    return (
      <div
        style={{ backgroundColor: 'white',
          color: data.isCurrentStage ? '#cdcece' : '#1c505d',
          fontSize: 14,
          padding: '8px 0 8px ',
          position: 'relative',
          lineHeight: '15px',
          paddingLeft: 12,
          fontFamily: 'Poppins',
          display: 'flex',
          cursor: 'pointer',
          ':active': {
            backgroundColor: data.isSelected ? 'rgba(50, 157, 156, 0.2);' : 'white',
          } }}
        {...innerProps}
      >
        <span>{label}</span>
        <span style={{ marginLeft: '5px' }}>{data.isUploaded ? <ReactSVG src={mark} /> : ''}</span>
      </div>
    );
  };
  return (
    <div className="previous-reports__selector-wrapper">
      <Select
        isClearable={false}
        isSearchable={false}
        closeMenuOnSelect
        options={options}
        styles={customStyles}
        defaultValue={defaultValue || options[0]}
        onChange={(e) => selectOnChange(e)}
        components={{
          IndicatorSeparator: () => null,
          Option: CustomOption,
        }}
      />
    </div>
  );
};

const PreviousReports = () => {
  const history = useHistory();
  const { state } = useContext(appStore);
  const { account } = state;
  const translate = useIntl();

  const { nameId } = useParams();

  const [initialError, setInitialError] = useState(false);
  const [selectorOption, setSelectorOptions] = useState([]);
  const [selectorValue, setSelectorValue] = useState();
  const [stageDuration, setStageDuration] = useState('');
  const [sampleZonesLength, setSampleZonesLength] = useState(0);

  const [totalData, setTotalData] = useState({});
  const [loadingData, setLoadingData] = useState(true);
  const [loadingPreview, setLoadingPreview] = useState(true);
  const [loadingSamplePlots, setLoadingSamplePlots] = useState(true);

  const [sampleZonesInfo, setSampleZonesInfo] = useState([]);
  const [chunkedSampleZones, setChunkedSampleZones] = useState([]);
  const [loadingStep, setLoadingStep] = useState(0);

  const [showPage, setShowPage] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [subInfo, setSubInfo] = useState({
    files: [],
    filesCidDir: '',
    additional: '',
    screenShot: '',
  });

  const listRef = useRef();
  const { ref } = useInView({
    root: listRef.current,
    threshold: 0,
    onChange: (inView) => {
      if (sampleZonesInfo.length < sampleZonesLength && inView) {
        (async () => {
          // eslint-disable-next-line no-use-before-define
          await loadSampleZones(chunkedSampleZones, loadingStep, selectorValue.value);
        })();
      }
    },
  });

  const origin = window?.location?.origin || '';
  const csvData = (sampleZonesInfo || []).flatMap((zone) => (zone.sampleTrees || []).map((tree, index) => {
    const treeName = tree.treeName || (tree.id ? `${zone.sampleName}_T${tree.id}` : zone.sampleName);
    const treePhoto = tree.treePhoto ? `${origin}/ipfs-image?cid=${tree.treePhoto}` : '';
    const treeTag = tree.labelPhoto ? `${origin}/ipfs-image?cid=${tree.labelPhoto}` : '';
    return {
      'Name Zone': index === 0 ? (zone.sampleName || '') : '',
      'Name trees': treeName || '',
      'Tree status': tree.status || '',
      'Height, m': tree.height || '',
      'Circumference, cm': tree.diameter || '',
      'Tree photo': treePhoto ? `=HYPERLINK("${treePhoto}";"Open")` : '',
      'Tree tag': treeTag ? `=HYPERLINK("${treeTag}";"Open")` : '',
    };
  }));

  const initialFailFunc = () => {
    setLoadingData(false);
    setLoadingPreview(false);
    setLoadingSamplePlots(false);
    setInitialError(true);
  };

  // Format: January 1, 2021 - December 21, 2021
  const getStageDuration = (stageId) => {
    const divider = 1e6;
    const stageStart = new Date(totalData.stages[stageId].starts_at / divider);
    const stageEnd = new Date(totalData.stages[stageId].ends_at / divider);

    const formattedStart = `${stageStart.toLocaleDateString('en-US', { month: 'long', day: '2-digit', year: 'numeric' })}`;
    const formattedEnd = `${stageEnd.toLocaleDateString('en-US', { month: 'long', day: '2-digit', year: 'numeric' })}`;
    return `${formattedStart} - ${formattedEnd}`;
  };

  const chunkArray = (myArray, chunkSize) => {
    const results = [];
    while (myArray.length) {
      results.push(myArray.splice(0, chunkSize));
    }
    return results;
  };

  const loadSampleZones = async (chunkArr, index, stageId) => {
    setLoadingSamplePlots(true);
    const ipfs = await initIPFS();

    const sZones = [...chunkArr[index]];

    const sampleZonesDetails = await Promise.all(
      sZones.map(async (item) => {
        if (item) {
          const { cid } = item.sampleTrees.historySampleTrees.find((el) => el.stageId === stageId);
          if (cid) {
            const treesJSON = await getJSONFileFromIpfs(ipfs, cid) || [];
            const parsedTreeJSON = treesJSON.map((tree, id) => {
              const treeName = Object.keys(tree)[0];
              const treeInfo = Object.values(tree)[0];
              return {
                id: tree.id ? tree.id : Date.now() + id,
                treeName,
                status: treeInfo.select.toLowerCase(),
                height: treeInfo.height,
                diameter: treeInfo.diametr,
                treePhoto: treeInfo.treeImage,
                labelPhoto: treeInfo.treeLabel,
              };
            });
            return { ...item, sampleTrees: parsedTreeJSON };
          }
          return { ...item, sampleTrees: [] };
        }
      }),
    );
    setSampleZonesInfo((prev) => prev.concat(sampleZonesDetails));
    setLoadingStep((prev) => prev + 1);
    setLoadingSamplePlots(false);
  };

  const getSelectorOptions = (stageId, isStagesFinished, uploadedOptions) => {
    const options = Array.from({ length: stageId + 1 }).map((_, index) => ({
      value: index,
      label: isStagesFinished || stageId !== index ? `Stage ${index + 1}` : `Stage ${index + 1} (Current Stage)`,
      isCurrentStage: !isStagesFinished && stageId === index,
      isUploaded: uploadedOptions[index],
    }));
    return options;
  };

  const getStageReportPreview = async (stageId) => {
    setLoadingPreview(true);
    const targetStage = totalData?.stages[stageId];
    const hasStageReport = targetStage?.data_upload_at;

    if (hasStageReport) {
      const targetStageInfo = totalData.stagesInfo.find((item) => item.stage === stageId);
      const targetSubZone = totalData.subZones.find((item) => item.subId === targetStageInfo?.subId);
      const targetSampleZones = totalData.sampleZones.filter((item) => (
        item.sampleTrees.historySampleTrees.find((el) => el.stageId === stageId)
      ));

      const updSubInfo = {};

      if (targetStageInfo?.filesCidDir) {
        const cid = targetStageInfo.filesCidDir;

        const ipfs = await initIPFS();
        const files = await getFilesFromDirectory(ipfs, cid);

        updSubInfo.files = files?.length ? files : [];
        updSubInfo.filesCidDir = cid;
      }

      updSubInfo.subZones = [targetSubZone] || [];
      updSubInfo.sampleZones = targetSampleZones || [];
      updSubInfo.polygon = totalData.polygon || [];
      updSubInfo.additional = targetStageInfo?.additional || '';
      updSubInfo.screenShot = targetSubZone?.cidSampleScreenShot || '';

      const chunks = chunkArray([...targetSampleZones], 20);

      setSampleZonesInfo([]);
      setLoadingStep(0);
      setChunkedSampleZones(chunks);
      setSampleZonesLength(targetSampleZones.length);
      setSubInfo(updSubInfo);
      setShowPreview(true);
    } else setShowPreview(false);
    setLoadingPreview(false);
  };

  const successFunc = async (data) => {
    const token = data?.hits?.hits?.length && data?.hits?.hits[0]._source;
    const fields = data?.hits?.hits?.length && data?.hits?.hits[0].fields;

    if (token && fields) {
      if (token.status?.toLowerCase() === REGISTER_STATUS) {
        setTotalData(token);
        setLoadingData(false);
        setShowPage(false);
        return;
      }

      const isStagesFinished = getMapping(fields.isStagesFinished);
      const stageId = isStagesFinished ? token.stages.length - 1 : getMapping(fields.currentStage);
      const uploadedOptions = token.stages.map((el) => !!el?.data_upload_at);
      const options = getSelectorOptions(stageId, isStagesFinished, uploadedOptions);
      setTotalData(token);
      setSelectorOptions(options);
      setSelectorValue(options[options.length - 1]);
      setShowPage(true);
      setLoadingData(false);
    } else initialFailFunc();
  };

  // Fetch project from indexer
  useEffect(async () => {
    if (account) {
      const bodyReq = {
        runtime_mappings: { ...runtimeMappings },
        fields: ['currentStage', 'isStagesFinished'],
        query: {
          bool: {
            must: [
              {
                match: {
                  'project_id.keyword': nameId,
                },
              },
              {
                match: {
                  'signer_id.keyword': account.accountId,
                },
              },
            ],
          },
        },
      };

      const { result, statusCode } = await sendRequest(indexerApi, 'POST', JSON.stringify(bodyReq), false);
      handleResponseStatus(
        statusCode,
        () => successFunc(result),
        () => initialFailFunc(),
      );
    }
  }, [account]);

  // Get stage report for selected value
  useEffect(async () => {
    if (showPage) {
      await getStageReportPreview(selectorValue.value);
      setStageDuration(getStageDuration(selectorValue.value));
    }
  }, [showPage, selectorValue?.value]);

  // Load sample zones info for selected value
  useEffect(async () => {
    if (chunkedSampleZones.length) {
      await loadSampleZones(chunkedSampleZones, loadingStep, selectorValue.value);
    }
  }, [chunkedSampleZones]);

  if (loadingData) {
    return (
      <div className="dashboard__loader">
        <Loader />
      </div>
    );
  }

  // If first render request failed
  if (initialError) {
    return (
      <RequestModal
        error
        handleClose={() => history.push('/')}
        title={translate.formatMessage({ id: 'modal.title.oops' })}
        description={(
          <FormattedMessage
            id="modal.description.somethingGoesWrong"
            values={{
              link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="text-anchor">{chunks}</a>,
            }}
          />
)}
      />
    );
  }

  if (!totalData?.status?.toLowerCase()) {
    return (
      <RequestModal
        error
        handleClose={() => history.push('/')}
        title={translate.formatMessage({ id: 'modal.description.canNotTrack' })}
        description={translate.formatMessage({ id: 'modal.description.canNotTrack' })}
        buttonText={translate.formatMessage({ id: 'modal.button.return' })}
      />
    );
  }

  return (
    <div className="previous-reports">
      <div className="previous-reports__wrapper">
        {totalData?.status?.toLowerCase() === REGISTER_STATUS ? (
          <p className="previous-reports__nothing">
            {translate.formatMessage({ id: 'previousReports.nothingToPreview' })}
          </p>
        ) : showPage ? (
          <>
            <div className="previous-reports__stage-wrapper">
              <CustomSelect
                defaultValue={selectorValue}
                options={selectorOption}
                selectOnChange={setSelectorValue}
              />
              <div className="previous-reports__stage-calendar">
                <i className="icon-event" />
                <span>{stageDuration}</span>
              </div>
            </div>
            {loadingPreview ? (
              <div className="dashboard__loader">
                <Loader />
              </div>
            ) : showPreview ? (
              <div className="previous-reports__body">
                <MapMini state={subInfo} />
                {!!sampleZonesInfo.length && (
                  <CSVLink
                    data={csvData}
                    filename={`sample-zones-stage-${selectorValue?.value || 1}.csv`}
                    className="btn btn__download-zone upload-wizard__download-csv sample"
                    separator=";"
                  >
                    {translate.formatMessage({ id: 'previewSampleZone.downloadCsv' })}
                  </CSVLink>
                )}
                <div className="previous-reports__sz-list" ref={listRef}>
                  {sampleZonesInfo.map((zone, id) => (
                    <PreviewSampleZone
                      sampleName={zone.sampleName}
                      sampleRadius={zone.sampleRadius}
                      coordinates={zone.coordinates}
                      sampleTrees={zone.sampleTrees}
                      isLastElem={id === sampleZonesInfo.length - 1}
                      ref={ref}
                      isPreviousStage
                      key={`${zone.sampleName}${zone.id}`}
                    />
                  ))}
                  {loadingSamplePlots && <Loader customClass="lds-ring__small" />}
                </div>
                <div className="previous-reports__subinfo">
                  {!!subInfo.files?.length && (
                  <div className="previous-reports__subinfo-wrapper">
                    <h4 className="previous-reports__documents-label">
                      {translate.formatMessage({ id: 'previousReports.additionalDocuments' })}
                    </h4>
                    <div className="previous-reports__documents-list">
                      {subInfo.files.map((item, index) => (
                        <a
                          className="previous-reports__documents-item"
                          href={buildGatewayUrl(subInfo.filesCidDir, item.path)}
                          target="_blank"
                          rel="noreferrer"
                          key={item.path}
                        >
                          {`${index + 1}. ${item.path}`}
                        </a>
                      ))}
                    </div>
                  </div>
                  )}
                  {!!subInfo.additional && (
                    <div className="previous-reports__subinfo-wrapper">
                      <h4 className="previous-reports__documents-label">
                        {translate.formatMessage({ id: 'previousReports.additionalComments' })}
                      </h4>
                      <p className="previous-reports__documents-comments">
                        {subInfo.additional}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <p className="previous-reports__nothing">
                {translate.formatMessage({ id: 'previousReports.nothingToPreview' })}
              </p>
            )}
          </>
        ) : (
          <p className="previous-reports__nothing">
            {translate.formatMessage({ id: 'previousReports.nothingToPreview' })}
          </p>
        )}
      </div>
    </div>
  );
};

export default React.memo(PreviousReports);
